import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Snackbar } from "@mui/material";
import React from "react";
import { useFormattedCopy } from "../hooks/useFormattedCopy";

interface CopyButtonProps {
  elementId: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ elementId }) => {
  const { handleCopy, copySnackbarOpen, handleSnackbarClose } =
    useFormattedCopy({
      elementId,
    });

  return (
    <>
      <ContentCopyIcon fontSize="small" onClick={handleCopy} />
      <Snackbar
        open={copySnackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message="Message copied."
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
};
